import React from "react";
import { SectionTitle } from "@/components/Bits";
import { useLang } from "@/context/LanguageContext";

const Block = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-serif text-2xl font-semibold text-navy mb-3">{title}</h2>
    <div className="text-slate-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Privacy() {
  const { t, lang } = useLang();
  const blocks = t("pages.privacy.blocks");
  const locale = lang === "en" ? "en-US" : "fr-FR";
  return (
    <div className="bg-ivory min-h-screen">
      <section className="bg-navy py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <SectionTitle light eyebrow={t("pages.privacy.eyebrow")} title={t("pages.privacy.title")} subtitle={t("pages.privacy.subtitle")} />
        </div>
      </section>
      <div className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-16 py-12" data-testid="privacy-content">
        <p className="text-sm text-slate-400 mb-8">{t("pages.privacy.updated")} : {new Date().toLocaleDateString(locale)}</p>
        {blocks.map((b) => <Block key={b.t} title={b.t}><p>{b.c}</p></Block>)}
      </div>
    </div>
  );
}
